<template>
    <div class="navbar justify-between flex">
        <div class="navbar-user navbar-btn flex items-center pt-10">
            <img src="@/assets/images/-layout/icon-login-user.png" alt="" /> {{ get(user, 'name') }}
        </div>
        <div class="navbar-title flex items-center flex-col justify-center">
            <h1>政华公考电子化考试系统</h1>
            <p v-if="!isSystem">公安专业科目</p>
        </div>
        <div class="navbar-menu flex justify-between pt-10 items-center">
            <div v-if="isHome" class="navbar-btn flex flex-col" @click="goPassword">
                <span class="material-icons navbar-pwd">lock</span> 密码
            </div>
            <div v-else class="navbar-btn flex flex-col" @click="goHome">
                <span class="material-icons">home</span> 首页
            </div>
            <div class="navbar-btn flex flex-col" @click="onBack">
                <span class="material-icons">fast_rewind</span> 后退
            </div>
            <div class="navbar-btn flex flex-col" @click="logout">
                <span class="material-icons">logout</span> 登出
            </div>
            <div class="navbar-btn flex flex-col items-center justify-center" @click="goSelect" v-if="router.currentRoute.value.name === 'home.index'">
                <img src="@/assets/images/-layout/home-select.png" class="" alt>
                科目
            </div>
        </div>
        <img class="navbar-logo" src="@/assets/images/-layout/logo-630x130.png" alt="" />
    </div>
</template>

<script setup>
import { get } from 'lodash-es'
import router from "@/router";
import { computed } from "vue";
import { clearLocalStorage } from "@/utils/util";
import { useStoreApp } from "@/store/app";

const appStore = useStoreApp();

const isSystem = computed(() => {
    return (router.currentRoute.value.name === 'home.system' || router.currentRoute.value.name === 'my.password')
})
const isHome = computed(() => {
    return router.currentRoute.value.name === 'home.system'
})

const logout = () => {
    clearLocalStorage();
    router.push({
        name: 'user.login',
    })
}
const goSelect = () => {
    router.push({
        name: 'home.system',
    })
}
const goHome = () => {
    if (router.currentRoute.value.name === 'my.password') {
        router.push({
            name: 'home.system'
        })
        return;
    }
    router.currentRoute.value.name !== 'home.index' && router.push('/')
}
const goPassword = () => {
    router.push({
        name: 'my.password'
    })
}
const onBack = () => {
    router.back()
}
const user = computed(() => appStore.user);

</script>

<style lang="less" scoped>
.navbar {
    background-image: url('../../assets/images/-layout/bg-header.png');
    background-size: 100% 100%;
    height: 76px;
    margin-bottom: 10px;
    background-repeat: no-repeat;
    position: relative;
    &-user {
        min-width: 175px;
        font-size: 14px;
        padding-bottom: 5px;
        color: #fff;
        cursor: pointer;
        padding-left: 20px;
        img {
            margin-right: 5px;
        }
    }
    &-pwd {
        color: rgb(185 28 28) !important;
    }
    &-btn {
        transition: all 0.2s;
        cursor: pointer;
        &:hover {
            transform: scale(1.2);
        }
    }
    &-title {
        font-weight: bold;
        color: #fff;
        height: 76px;
        h1 {
            font-size: 20px;
            line-height: 1;
            margin: 0;
        }
        p {
            font-size: 14px;
        }
    }

    &-logo {
        position: absolute;
        width: 76px;
        right: 20px;
        top: 6px;
    }

    &-menu {
        min-width: 165px;
        padding-right: 20px;
        font-size: 14px;
        color: #fff;
        .material-icons {
            color: #1d87ef;
            font-size: 24px;
        }
        img {
            width: 24px;
        }
    }
}

@media screen and (max-width: 1199px) {
    .navbar{
        .navbar-menu {
            min-width: 140px;
            .navbar-btn {

            }
        }
    }
}

</style>
